module.exports = __webpack_public_path__ + "media/product/ctg-5-0c0d5476.png";